import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { PictureComponent } from 'src/app/shared/components/picture/picture.component';
import { StoryblokCdnPipe } from '../../pipes/storyblok-cdn.pipe';
import { StoryblokImage } from '../../storyblok-types';
import { StoryblokDirective } from '../../storyblok.directive';
import { BlockStyle, BlockWrapperComponent, getPageWidth } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-gallery-showcase-list',
  standalone: true,
  templateUrl: './gallery-showcase-list.component.html',
  styleUrls: ['./gallery-showcase-list.component.scss'],
  imports: [CommonModule, BlockWrapperComponent, StoryblokDirective, PictureComponent, StoryblokCdnPipe],
})
export class GalleryShowcaseListComponent implements OnChanges {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() style: BlockStyle[];

  @Input() items: { _editable: string; link: string; screenshot: StoryblokImage }[];
  maxWidth: number;

  ngOnChanges(): void {
    this.maxWidth = getPageWidth(this.style?.[0]?.pageWidth, this.style?.[0]?.customPageWidth);
  }
}
